import React from "react";
import { Link } from "react-router-dom";
import OfferingCard from "../components/OfferingCard";
import RequestCallForm from "../components/RequestCallForm";
import { ReadMore } from "../components/Disclosure";
import config from "../config";
import {
  BUNDLES,
  BUNDLE_CANCELLATION_TEXT,
  BUNDLE_PER_SESSION_TEXT,
  STUDENT_ELIGIBILITY,
  emailHref,
  paymentMethodText,
  sessionCancellationText,
} from "../data/offerings";
import { CURRENCY_NOTE } from "../data/practice";
import "./Offerings.css";

/** Packages & bundles: purchased by email, paid by transfer or cheque. */
export default function Packages() {
  const email = config.business.contactEmail;
  return (
    <section className="section white offerings-page">
      <div className="container">
        <h1>Packages &amp; Bundles</h1>
        <div className="offering-intro">
          <p>
            Bundles are purchased by email. Email{" "}
            <a className="text-link" href={emailHref("Bundle purchase")}>{email}</a> to purchase a bundle.
          </p>
          <p className="muted currency-note">{CURRENCY_NOTE}</p>
        </div>

        <div className="services offering-grid">
          {BUNDLES.map((b) => (
            <OfferingCard
              key={b.id}
              id={b.id}
              title={b.title}
              meta={`$${b.price}`}
              lead={b.short}
              cta={
                <a className="btn-cta" href={emailHref(`${b.title} purchase`)}>
                  Email to purchase<span className="sr-only">: {b.title}</span>
                </a>
              }
            >
              {b.intro.map((p) => (
                <p key={p}>{p}</p>
              ))}
              {b.more.length ? (
                <ReadMore context={b.title}>
                  {b.more.map((p) => (
                    <p key={p}>{p}</p>
                  ))}
                </ReadMore>
              ) : null}
              <p className="bundle-investment"><strong>Investment: ${b.price}</strong></p>
              <p className="bundle-split">{b.split}</p>
            </OfferingCard>
          ))}
        </div>

        <div className="offering-notes">
          <h2>Student Eligibility</h2>
          {STUDENT_ELIGIBILITY.map((p) => (
            <p key={p}>{p}</p>
          ))}

          <h2>Payment</h2>
          <p>{paymentMethodText(email)}</p>
          <p>{BUNDLE_PER_SESSION_TEXT}</p>

          <h2>Cancellation Policy</h2>
          <p>
            {sessionCancellationText(undefined, { nonRefundable: false })} {BUNDLE_CANCELLATION_TEXT} Read more in my{" "}
            <Link className="text-link" to="/policies#refund">Refund &amp; Cancellation Policy</Link> for full details.
          </p>

          <p className="muted offering-help">
            Need help choosing a service? Request a call, and I’ll call you at a time that works for you.
          </p>
          <RequestCallForm collapsible />
        </div>
      </div>
    </section>
  );
}
